import React, { Component } from 'react';
import { FormattedMessage } from 'react-intl';
import uniqBy from 'lodash/uniqBy';

import { completeUrlsForFile, paginate, endPage } from "../../util/utils";
import api from "../../config/api";
import FileList from "../common/FileList";
import PaginationButton from "../common/PaginationButton";

class SupportPage extends Component{

	constructor(){
		super();
		this.state = {
			defaultSize: 5,
			tutorialSize: 3,
			webleaflets: {
				all: [],
				paginated: [],
				size: 0,
				actual: 1,
				end: 1,
			},
			userManuals: {
				all: [],
				paginated: [],
				size: 0,
				actual: 1,
				end: 1,
			},
			firmwares: {
				all: [],
				paginated: [],
				size: 0,
				actual: 1,
				end: 1,
			},
			tutorials: {
				all: [],
				paginated: [],
				size: 0,
				actual: 1,
				end: 1,
			}
		};
	}

	/**
	 * Load the products on first mount
	 */
	componentWillMount(){
		const {selectedLanguage} = this.props;
		this.loadWebleaflets(selectedLanguage);
		this.loadUserManuals(selectedLanguage);
		this.loadFirmwares(selectedLanguage);
		this.loadTutorials(selectedLanguage);
	}

	/**
	 * Load other products if the route is changed
	 * @param nextProps - the props that will be received next
	 */
	componentWillReceiveProps(nextProps) {
		const {selectedLanguage, match} = nextProps;
		if(this.props.match.url !== match.url) {
			this.setState({
				webleaflets: {
					all: [],
					paginated: [],
					size: 0,
					actual: 1,
					end: 1
				},
				userManuals: {
					all: [],
					paginated: [],
					size: 0,
					actual: 1,
					end: 1
				},
				firmwares: {
					all: [],
					paginated: [],
					size: 0,
					actual: 1,
					end: 1
				},
				tutorials: {
					all: [],
					paginated: [],
					size: 0,
					actual: 1,
					end: 1
				}
			});
			this.loadWebleaflets(selectedLanguage);
			this.loadUserManuals(selectedLanguage);
			this.loadFirmwares(selectedLanguage);
			this.loadTutorials(selectedLanguage);
		}
	}

	loadWebleaflets = (language) => {
		fetch(api.supportWebleaflets(language.codeCountry))
			.then(res => res.json())
			.then(data => {
				const all = uniqBy(completeUrlsForFile(data),'link');
				const size = all.length;
				this.setState({
					webleaflets: {
						all: all,
						paginated: paginate(all,this.state.defaultSize,1),
						size: size,
						actual: 1,
						end: endPage(all,this.state.defaultSize)
					}
				});
			}).catch(err => console.error(err));
	};

	loadUserManuals = (language) => {
		fetch(api.supportUserManuals(language.codeCountry))
			.then(res => res.json())
			.then(data => {
				const all = uniqBy(completeUrlsForFile(data),'link');
				const size = all.length;
				this.setState({
					userManuals: {
						all: all,
						paginated: paginate(all,this.state.defaultSize,1),
						size: size,
						actual: 1,
						end: endPage(all,this.state.defaultSize)
					}
				});
			}).catch(err => console.error(err));
	};

	loadFirmwares = (language) => {
		fetch(api.supportFirmwares(language.codeCountry))
			.then(res => res.json())
			.then(data => {
				const all = uniqBy(completeUrlsForFile(data),'link');
				const size = all.length;
				this.setState({
					firmwares: {
						all: all,
						paginated: paginate(all,this.state.defaultSize,1),
						size: size,
						actual: 1,
						end: endPage(all,this.state.defaultSize)
					}
				});
			}).catch(err => console.error(err));
	};

	loadTutorials = (language) => {
		fetch(api.supportTutorials(language.codeCountry))
			.then(res => res.json())
			.then(data => {
				const all = uniqBy(data,'link');
				const size = all.length;
				this.setState({
					tutorials: {
						all: all,
						paginated: paginate(all,this.state.tutorialSize,1),
						size: size,
						actual: 1,
						end: endPage(all,this.state.tutorialSize)
					}
				});
			}).catch(err => console.error(err));
	};

	handlePagination = (e, type, next, isDisabled) => {
		if(isDisabled){
			return;
		}

		const page = this.state[type];
		const size = type.includes('tutorials') ? this.state.tutorialSize : this.state.defaultSize;

		if(next && page.actual < page.end){
			++page.actual;
		}

		if (!next && page.actual > 1) {
			--page.actual;
		}

		page.paginated = paginate(page.all,size,page.actual);

		this.setState({
			[type]:page
		})
	};

	paginationButtonIsDisabled = (type, next) => {
		const page = this.state[type];
		return page.end < 1  ? true : next ? page.actual === page.end : page.actual === 1;
	};

	renderTutorial = (file, index) => {
		return (
			<div className="tutorial-item" key={index}>
				<div className="embed-responsive embed-responsive-16by9">
					<iframe className="embed-responsive-item" src={file.link} frameBorder="0"
					        allow="autoplay; encrypted-media" allowFullScreen/>
				</div>
				<h3>{file.name}</h3>
			</div>
		)
	};

	render(){
		const {webleaflets, userManuals, firmwares, tutorials} = this.state;
		const { page } = this.props;
		return (
			<div className="container-flex">
				<div className="page__banner page__banner--support">
					<h2>
						<FormattedMessage id={"page.title."+page.title.toLowerCase().replace(" ","-")} />
					</h2>
				</div>
				<div className="page">
					<div className={page.contentClass}>
						<h2 className="support-title">
							<FormattedMessage id="title.download" />
						</h2>
						<div className="row">
							<div className="col-md-6 support-webleaflet">
								<h3 className="support-title support-title--small">
									<FormattedMessage id="title.webleaflet" />
								</h3>
								<FileList files={webleaflets.paginated}/>
								<div className="file-list-pagination">
									<PaginationButton
										btnClassName="btn btn-next"
										onClickHandler={this.handlePagination}
										iconClassName="fa fa-angle-left"
										langKey="button.next.webleaflet"
										type="webleaflets"
										isDisabled={this.paginationButtonIsDisabled}
										isNext={true}
									/>
									<PaginationButton
										btnClassName="btn btn-prev"
										onClickHandler={this.handlePagination}
										iconClassName="fa fa-angle-right"
										langKey="button.prev.webleaflet"
										type="webleaflets"
										isDisabled={this.paginationButtonIsDisabled}
										isNext={false}
									/>
								</div>
							</div>
							<div className="col-md-6 support-userManual">
								<h3 className="support-title support-title--small">
									<FormattedMessage id="title.user-manual" />
								</h3>
								<FileList files={userManuals.paginated}/>
								<div className="file-list-pagination">
									<PaginationButton
										btnClassName="btn btn-next"
										onClickHandler={this.handlePagination}
										iconClassName="fa fa-angle-left"
										langKey="button.next.user-manual"
										type="userManuals"
										isDisabled={this.paginationButtonIsDisabled}
										isNext={true}
									/>
									<PaginationButton
										btnClassName="btn btn-prev"
										onClickHandler={this.handlePagination}
										iconClassName="fa fa-angle-right"
										langKey="button.prev.user-manual"
										type="userManuals"
										isDisabled={this.paginationButtonIsDisabled}
										isNext={false}
									/>
								</div>
							</div>
						</div>
						<div className="support-firmware">
							<h3 className="support-title support-title--small">
								<FormattedMessage id="title.firmware" />
							</h3>
							<FileList files={firmwares.paginated}/>
							<div className="file-list-pagination">
								<PaginationButton
									btnClassName="btn btn-next"
									onClickHandler={this.handlePagination}
									iconClassName="fa fa-angle-left"
									langKey="button.next.firmware"
									type="firmwares"
									isDisabled={this.paginationButtonIsDisabled}
									isNext={true}
								/>
								<PaginationButton
									btnClassName="btn btn-prev"
									onClickHandler={this.handlePagination}
									iconClassName="fa fa-angle-right"
									langKey="button.prev.firmware"
									type="firmwares"
									isDisabled={this.paginationButtonIsDisabled}
									isNext={false}
								/>
							</div>
						</div>
						<h2 className="support-title">
							<FormattedMessage id="title.tutorial" />
						</h2>
						<div className="support-tutorial">
							{tutorials.paginated.map(this.renderTutorial)}
						</div>
						<div className="file-list-pagination">
							<PaginationButton
								btnClassName="btn btn-next"
								onClickHandler={this.handlePagination}
								iconClassName="fa fa-angle-left"
								langKey="button.next.tutorial"
								type="tutorials"
								isDisabled={this.paginationButtonIsDisabled}
								isNext={true}
							/>
							<PaginationButton
								btnClassName="btn btn-prev"
								onClickHandler={this.handlePagination}
								iconClassName="fa fa-angle-right"
								langKey="button.prev.tutorial"
								type="tutorials"
								isDisabled={this.paginationButtonIsDisabled}
								isNext={false}
							/>
						</div>
					</div>
				</div>
			</div>
		);
	}
}

export default SupportPage;


// WEBPACK FOOTER //
// ./src/components/page/SupportPage.js